import Http from '../../services/Http';
// import { handleApiError } from '../../Utils/errorHandler'; // TPX-2793: only used by the commented-out fetchStrData
import { HTTP_STATUS } from '../../constants/keywords';

// TPX-2793: unused; GET /critique/str-data is commented out in the backend. Uncomment both to re-enable.
// export const fetchStrData = (propertyId, year, month, showToast) => {
//   return Http.GET(`/critique/str-data?propertyId=${propertyId}&year=${year}&month=${month}`)
//     .then((res) => res.data)
//     .catch((err) => {
//       handleApiError(err, showToast);
//       return null;
//     });
// };

/**
 * Soft delete one or more critiques. Rejects on failure so callers (e.g. DeleteModal)
 * can keep the confirm dialog open.
 */
export const deleteCritiques = (critiqueIds) => {
  // Comma-separated so Spring binds it to List<Long>; one endpoint for single and bulk.
  return Http.DELETE('/critique', { params: { ids: critiqueIds.join(',') } });
}

/**
 * Active (non-archived) critique templates of the hotel group, as [{ value: id, label: name }]
 * sorted by name. Errors propagate so the caller can show a toast.
 */
export const fetchActiveCritiqueTemplateOptions = async (hmgId) => {
  const res = await Http.GET('/critique-templates', { params: { hmgId } });
  const templates = Array.isArray(res?.data) ? res.data : [];
  return templates
    .map((t) => ({ value: t.id, label: t.critique_name || 'Untitled Template' }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

/**
 * Option sources for the "Always include" / "Always exclude" pickers: functional codes plus the
 * department rows (with sub-departments). Falls back to the flat department list only when the
 * sub-department call returns no rows. Errors propagate so the caller can lock the pickers.
 */
export const fetchAlwaysListsPickerData = async (organizationId) => {
  const [deptSubRes, glCodesRes] = await Promise.all([
    Http.GET(`department-mappings/with-sub-departments?hmgId=${organizationId}`),
    Http.GET(`/chart-of-accounts/functional-codes/${organizationId}`),
  ]);

  const subRows =
    deptSubRes?.status === HTTP_STATUS.OK && Array.isArray(deptSubRes.data) ? deptSubRes.data : [];

  let fallbackDepartments = [];
  if (subRows.length === 0) {
    const departmentsRes = await Http.GET(
      `plan-details/get-all-departments?organizationId=${organizationId}`
    );
    if (departmentsRes?.status === HTTP_STATUS.OK && Array.isArray(departmentsRes.data)) {
      fallbackDepartments = departmentsRes.data;
    }
  }

  const functionalCodes =
    glCodesRes?.status === HTTP_STATUS.OK && Array.isArray(glCodesRes.data) ? glCodesRes.data : [];

  return { subRows, fallbackDepartments, functionalCodes };
};

/**
 * Department / sub-department membership of every account across the template's hotels
 * ([{ coa_id, department_ids, department_mapping_ids }]). "No access to this template's
 * organization" comes back as a 400 (not 401), so it does not trigger the global logout.
 */
export const fetchTemplateAccountMembership = async (templateId) => {
  const res = await Http.GET(`/critique-templates/${templateId}/account-membership`);
  if (res?.status !== HTTP_STATUS.OK || !Array.isArray(res.data?.accounts)) {
    throw new Error('Unexpected account membership response');
  }
  return res.data.accounts;
};
